// extracted by mini-css-extract-plugin
export default {"PopoverWrapper":"ConcessionUserItem_PopoverWrapper__dtUYN","Role":"ConcessionUserItem_Role__aQxfS"};